var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 11 9",
    fill: "#12A482",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkmark-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "checkmark-icon_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6423 0.200735C11.0588 0.513635 11.1229 1.08037 10.7855 1.46658L4.49464 8.66656C4.32055 8.86581 4.06306 8.98674 3.78682 8.99897C3.51058 9.01121 3.24183 8.91359 3.04804 8.73064L0.280076 6.11731C-0.0955308 5.76269 -0.0899946 5.19287 0.292442 4.84458C0.674878 4.49629 1.28939 4.50142 1.665 4.85604L3.67095 6.74992L9.2772 0.333471C9.61464 -0.0527373 10.2258 -0.112165 10.6423 0.200735Z",
    fill: "#12A482"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkIcon);
export default __webpack_public_path__ + "static/media/checkmark-icon.aaa6c3da64634bffb0f0ae6c590f288e.svg";
export { ForwardRef as ReactComponent };